import { CardsIncompleteData as Component } from './CardsIncompleteData';
import { CardsIncompleteDataSkeleton as Skeleton } from './CardsIncompleteDataSkeleton';

export const CardsIncompleteData = Object.assign(Component, {
  Skeleton,
});
